import { T, useT } from "@repo/transifex";
import { ReportCard, ReportPriceRow, ReportRow } from "~/components/report";
import { useVatLabel } from "~/hooks/use-vat-label";

import { type SalesSummaryData } from "./types";
import { negatePrice } from "./utils";

type SalesSummarySectionProps = {
  data: SalesSummaryData;
  title?: string;
  /** When provided, renders a "Number of products sold" count row (per-till). */
  productsSold?: number;
};

export const SalesSummarySection = ({
  data,
  title,
  productsSold
}: SalesSummarySectionProps) => {
  const t = useT();
  const { vatLabel } = useVatLabel();

  return (
    <ReportCard title={title ?? <T _str="Sales Summary" />}>
      <ReportPriceRow
        label={t("Gross Sales")}
        value={data.grossSales}
        currency={data.currency}
        variant="bold"
      />
      <ReportPriceRow
        label={t("Discounts")}
        value={negatePrice(data.discounts)}
        currency={data.currency}
        variant="indented"
      />
      <ReportPriceRow
        label={t("Sales after discounts")}
        value={data.salesAfterDiscounts}
        currency={data.currency}
        variant="bold"
      />
      <ReportPriceRow
        label={t("Refunds")}
        value={negatePrice(data.refunds)}
        currency={data.currency}
        variant="indented"
      />
      <ReportPriceRow
        label={t("Net Sales (incl. {vatLabel})", { vatLabel })}
        value={data.netSales}
        currency={data.currency}
        variant="bold"
      />
      {productsSold !== undefined && (
        <ReportRow label={t("Number of products sold")} value={productsSold} />
      )}
    </ReportCard>
  );
};
